import { Component, OnInit } from '@angular/core';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
import { SchedulerService } from '../../../Services/scheduler.service';
import { PopupModelReturn, Appointment, PopupButton, PopupModel, PopupSetupModel, Days, ServiceProvider, Patient, SP_Type, MeetingAppointment, AppointmentType, Users, Province, Branch, Roles, ServiceAreas, Lookups } from '../../../AllTableClasses';
import UserSession from '../../../Config/user-session';
import { LookupsService } from '../../../Services/lookups.service';

@Component({
  selector: 'app-meeting-setup-popup',
  templateUrl: './meeting-setup-popup.component.html',
  styleUrls: ['./meeting-setup-popup.component.scss']
})
export class MeetingSetupPopupComponent implements OnInit {
  popup: PopupSetupModel | null = null;
  popupReturn: PopupModelReturn = new PopupModelReturn();
  PopupAction: string = 'Setup';

  appointmentTypes: Array<AppointmentType> = new Array<AppointmentType>();
  appointments: Array<MeetingAppointment> = new Array<MeetingAppointment>();
  aapointment: Appointment = new Appointment();

  public submitted = false;
  
  users: Array<Users> = new Array<Users>();

  searchRequiredQuery: string = '';
  searchOptionalQuery: string = '';

  filteredRequiredUsers: Array<Users> = [];
  selectedRequiredUsers: Array<Users> = [];

  filteredOptionalUsers: Array<Users> = [];
  selectedOptionalUsers: Array<Users> = [];

  selectedProvince: Province = new Province();
  selectedBranch: Branch = new Branch();

  provinces: Array<Province> = [];
  branches: Array<Branch> = [];

  roles: Array<Roles> = new Array<Roles>();
  selectedRoles: string = '';
  SelectedRoleName!: string;
  selectedStartDate: string = '';

  //recurrence date and time start
  recurrenceStartDate: string = '';
  recurrenceEndDate: string = '';
  selectedStartRecurringTime: string = '';
  selectedEndRecurringTime: string = '';
  //recurrence date and time end

  isAllDay: boolean = false;

  selectedfrequency: string = 'daily';
  recurrence: number = 1;
  appointmentDates: Date[] = [];

  selectedDays: Days = new Days();

  daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];


  public AppointmentTypeDropDown: boolean = false;
  public selectedAppointmentType!: string;
  public GroupDropDown: boolean = false;

  public ProvinceDropDown: boolean = false;
  public BranchDropDown: boolean = false;
  public times: Array<Lookups> = new Array<Lookups>();
  public StartTimeDropdownOpen: boolean = false;
  public EndTimeDropdownOpen: boolean = false;

  public showError: boolean = false;
  public erroMessage!: string;

  serviceAreas: Array<ServiceAreas> = new Array<ServiceAreas>();
  selectedServiceAreaID!: number;

  public meetingAppointment: MeetingAppointment = new MeetingAppointment();

  constructor(
    private popupNotificationService: PopupNotificationService,
    public schedulerService: SchedulerService,
    private lookupService: LookupsService,
  ) { }

  ngOnInit(): void {
    this.popupNotificationService.meetingNotification$.subscribe((popup: PopupSetupModel | null) => {
      this.popup = popup;
      if (popup) {
        this.TimesGet();
        this.AppointmentTypeGet();
        this.RolesGet();
        this.ProvinceGet();
        
        if (popup?.Data != null || popup?.Data != undefined) {

          this.meetingAppointment = popup.Data;
          this.UsersGet();
          this.ServiceAreasGet();
          this.selectedStartRecurringTime = this.meetingAppointment.StartTime;
          this.recurrenceStartDate = this.meetingAppointment.StartDate;
        }
      }
    });
  }

  public ServiceAreasGet() {
    this.schedulerService.ServiceAreasGetByBranchID(this.meetingAppointment.BranchID, (data: any) => {
      if (data.Success) {
        this.serviceAreas = JSON.parse(data.Data);

      } else {
        console.error('Error fetching serviceAreas:', data.Message);
      }
    }, (error: any) => { });
  }

  toggleAppointmentTypeDropdown() {
    this.AppointmentTypeDropDown = !this.AppointmentTypeDropDown;
  }
  selectAppointmentType(appointmentType: AppointmentType) {
    this.selectedAppointmentType = appointmentType.Name;
    this.aapointment.ServiceProviderID = appointmentType.ID
    this.AppointmentTypeDropDown = false;
  }

  //togglGroupDropdown() {
  //  this.GroupDropDown = !this.GroupDropDown;
  //}
  //selectGroup(role: Roles) {
  //  this.selectedRoles = role.ID.toString();
  //  this.SelectedRoleName = role.RoleName;
  //  this.GroupDropDown = false;
  //}

  //togglProvinceDropdown() {
  //  this.ProvinceDropDown = !this.ProvinceDropDown;
  //}
  //selectProvince(province: Province) {
  //  this.selectedProvince = province;
  //  this.BranchGetByProvinceID(this.selectedProvince.ID);
  //  this.ProvinceDropDown = false;
  //}

  //togglBranchDropdown() {
  //  this.BranchDropDown = !this.BranchDropDown;
  //}
  //selectBranch(branch: Branch) {
  //  this.selectedBranch = branch;
  //  this.BranchDropDown = false;
  //}

  toggleStartTimesDropdown() {
    this.StartTimeDropdownOpen = !this.StartTimeDropdownOpen;
  }
  selectStartTime(time: Lookups) {
    const selectedTime = this.parseTime(time.Type);

    if (this.selectedEndRecurringTime) {
      const endTime = this.parseTime(this.selectedEndRecurringTime);

      if (selectedTime >= endTime) {
        //alert('Start time must be before end time.');
        this.showError = true;
        this.erroMessage = 'Start time must be before end time.';
        return;
      }
    }
    this.selectedStartRecurringTime = time.Type;
    this.StartTimeDropdownOpen = false;
  }
  toggleEndTimesDropdown() {
    this.EndTimeDropdownOpen = !this.EndTimeDropdownOpen;
  }
  selectEndTime(time: Lookups) {
    const selectedTime = this.parseTime(time.Type);

    if (this.selectedStartRecurringTime) {
      const startTime = this.parseTime(this.selectedStartRecurringTime);

      if (selectedTime <= startTime) {
        //alert('End time must be after start time.');
        this.showError = true;
        this.erroMessage = 'End time must be after start time.';
        return;
      }
    }
    this.selectedEndRecurringTime = time.Type;
    this.EndTimeDropdownOpen = false;
  }

  parseTime(time: string): Date {
    const [hours, minutes] = time.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0); // Set hours and minutes
    return date;
  }

  public TimesGet() {
    this.lookupService.TimesGet((data) => {
      if (data.Success) {
        this.times = data.Data;
      }
      else {

      }
    }, (error) => { })
  };

  RolesGet() {
    this.schedulerService.RolesGet((data: any) => {
      if (data.Success) {
        this.roles = JSON.parse(data.Data);

      } else {
        console.error('Error fetching provinces:', data.Message);
      }
    }, (error: any) => {
      console.error('Error fetching provinces:', error);
    });
  }

  ProvinceGet() {
    this.schedulerService.ProvinceGet((data: any) => {
      if (data.Success) {
        this.provinces = JSON.parse(data.Data);

      } else {
        console.error('Error fetching provinces:', data.Message);
      }
    }, (error: any) => {
      console.error('Error fetching provinces:', error);
    });
  }

  BranchGetByProvinceID(province: number) {
    this.schedulerService.BranchGetByProvinceID(province, (data: any) => {
      if (data.Success) {
        this.branches = JSON.parse(data.Data);

      } else {
        console.error('Error fetching branch:', data.Message);
      }
    }, (error: any) => {
      console.error('Error fetching branch:', error);
    });
  }

  UsersGetByBranchID() {
    this.schedulerService.UsersGetByBranchID(this.selectedBranch.ID, parseInt(this.selectedRoles), (data: any) => {
      if (data.Success) {
        this.selectedRequiredUsers = JSON.parse(data.Data);

      } else {
        console.error('Error fetching branch:', data.Message);
      }
    }, (error: any) => {
      console.error('Error fetching branch:', error);
    });
  }

  UsersGet() {
    this.schedulerService.StaffGetByBranchID(this.meetingAppointment.BranchID, (data: any) => {
      if (data.Success) {
        this.users = JSON.parse(data.Data);
        const defaultUser = this.users.filter(selected => selected.ID === this.meetingAppointment.StaffMemberID);
        this.selectedRequiredUsers.push(defaultUser[0]);
      } else {
        console.error('Error fetching appointmentType:', data.Message);
      }
    }, (error: any) => {
      console.error('Error fetching appointmentType:', error);
    });
  }

  filterUsers(): void {
    if (this.searchRequiredQuery) {
      this.filteredRequiredUsers = this.users.filter(user =>
        user.Name.toLowerCase().includes(this.searchRequiredQuery.toLowerCase()) ||
        user.Surname.toLowerCase().includes(this.searchRequiredQuery.toLowerCase())
      );
    } else {
      this.filteredRequiredUsers = [...this.users]; // Reset the list if search is empty
    }

    if (this.searchOptionalQuery) {
      this.filteredOptionalUsers = this.users.filter(user =>
        user.Name.toLowerCase().includes(this.searchOptionalQuery.toLowerCase()) ||
        user.Surname.toLowerCase().includes(this.searchOptionalQuery.toLowerCase())
      );
    } else {
      this.filteredOptionalUsers = [...this.users]; // Reset the list if search is empty
    }
  }

  isRequiredSelected(user: Users): boolean {
    return this.selectedRequiredUsers.some(selected => selected.ID === user.ID);
  }

  isOptionalSelected(user: Users): boolean {
    return this.selectedOptionalUsers.some(selected => selected.ID === user.ID);
  }

  toggleRequiredUser(user: Users): void {
    if (this.isRequiredSelected(user)) {
      this.selectedRequiredUsers = this.selectedRequiredUsers.filter(selected => selected.ID !== user.ID);
    } else {
      this.selectedRequiredUsers.push(user);
    }
  }

  toggleOptionalUser(user: Users): void {
    if (this.isRequiredSelected(user)) {
      this.selectedOptionalUsers = this.selectedOptionalUsers.filter(selected => selected.ID !== user.ID);
    } else {
      this.selectedOptionalUsers.push(user);
    }
  }

  removeRequiredUser(user: Users): void {
    this.selectedRequiredUsers = this.selectedRequiredUsers.filter(selected => selected.ID !== user.ID);
  }

  removeOptionalUser(user: Users): void {
    this.selectedRequiredUsers = this.selectedRequiredUsers.filter(selected => selected.ID !== user.ID);
  }

  AppointmentTypeGet() {
    this.schedulerService.AppointmentTypeGet((data: any) => {
      if (data.Success) {
        this.appointmentTypes = JSON.parse(data.Data);
        this.selectedAppointmentType = this.appointmentTypes.filter(appointmentType => appointmentType.ID === this.meetingAppointment.ServiceProviderID)[0].Name;
        this.aapointment.ServiceProviderID = this.meetingAppointment.ServiceProviderID;
      } else {
        console.error('Error fetching appointmentType:', data.Message);
      }
    }, (error: any) => {
      console.error('Error fetching appointmentType:', error);
    });
  }

  navigateToRecurrence() {
    this.PopupAction = 'Recurrence';
  }

  navigateToSetup() {
    this.PopupAction = 'Setup';
  }

  ButtonClick() {
    this.submitted = true;
    if (this.popup?.Button) {
      //if (this.patient.IDNumber.length == 13 && this.patient.Cellphone) {
      this.popupReturn.Result = this.popup.Button.Result;
      //this.patient.Active = true;
      this.popupReturn.Data = this.appointments;
      this.popupNotificationService.ResolveMeetingPopup(this.popupReturn);
      this.cancel();
      this.appointments = [];
    }
    this.submitted;

  }
  AltButtonClick() {
    if (this.popup?.AltButton) {
      this.popupReturn.Result = this.popup.AltButton.Result;
      this.popupNotificationService.ResolveMeetingPopup(this.popupReturn);
    }
    this.cancel();
  }

  cancel() {
    this.selectedStartDate = '';
    this.selectedStartRecurringTime = '';
    this.selectedAppointmentType = '';
    this.selectedEndRecurringTime = '';
    this.selectedServiceAreaID = 0;
    this.recurrenceStartDate = '';
    this.recurrenceEndDate = '';
    this.selectedRequiredUsers = [];
    this.selectedOptionalUsers = [];
    this.erroMessage = '';
    this.PopupAction = 'Setup';
  }

  PopupEvent(event: string) {
    if (event === 'close') {
      this.popupReturn.Result = 'close';
      this.popupNotificationService.ResolveMeetingPopup(this.popupReturn);
    }
    this.cancel();
    this.PopupAction = 'Setup'
  }

  allDayTimeSet() {
    if (!this.selectedStartDate) {
      console.error('Please select a start date.');
    }

    if (this.isAllDay) {
      this.aapointment.StartDate = this.selectedStartDate + '06:00';
      this.aapointment.EndDate = this.selectedStartDate + '18:00';
    }
  }

  calculateDates(): void {
    if (!this.recurrenceStartDate || !this.recurrenceEndDate) {
      this.showError = true;
      this.erroMessage = 'Please select a start and end date';
      return;
    }

    if (!this.selectedStartRecurringTime || !this.selectedEndRecurringTime) {
      this.showError = true;
      this.erroMessage = 'Please select a start and end time.';
      return;
    } else {
      let startTime = this.parseTime(this.selectedStartRecurringTime);
      let endTime = this.parseTime(this.selectedEndRecurringTime);

      // Check if both dates are available
      if (this.recurrenceStartDate && this.recurrenceEndDate) {
        const startDate = new Date(this.recurrenceStartDate);
        const endDate = new Date(this.recurrenceEndDate);

        // Check date range validity
        if (startDate > endDate) {
          this.showError = true;
          this.erroMessage = 'Start date must be before end date.';
          return;
        }

        // If dates are valid, check time range
        if (startDate.getTime() === endDate.getTime() && startTime >= endTime) {
          this.showError = true;
          this.erroMessage = 'Start time must be before end time if on the same date.';
          return;
        }
      }
    }

    const start = new Date(this.recurrenceStartDate);
    const end = new Date(this.recurrenceEndDate);

    // Reset appointment dates
    this.appointmentDates = [];

    // Loop through all days of the week to find selected ones
    for (let i = 0; i < this.daysOfWeek.length; i++) {
      if (this.selectedDays.Week[this.daysOfWeek[i]]) {
        // Get the next occurrences of the selected days within the start and end range
        const nextOccurrence = this.getNextDayOccurrence(start, i, this.recurrence, end);
        this.appointmentDates.push(...nextOccurrence);
      }
    }

    // Once dates are calculated, generate appointments for all staff members
    this.generateAppointmentsForStaff();
  }

  public MultiTimeSelectionValidation() {
    if (this.selectedStartRecurringTime && this.selectedEndRecurringTime) {
      let startTime = this.parseTime(this.selectedStartRecurringTime);
      let endTime = this.parseTime(this.selectedEndRecurringTime);

      // Check if both dates are available
      if (this.recurrenceStartDate && this.recurrenceEndDate) {
        const startDate = new Date(this.recurrenceStartDate);
        const endDate = new Date(this.recurrenceEndDate);

        // Check date range validity
        if (startDate > endDate) {
          this.showError = true;
          this.erroMessage = 'Start date must be before end date.';
          return;
        }

        // If dates are valid, check time range
        if (startDate.getTime() === endDate.getTime() && startTime >= endTime) {
          this.showError = true;
          this.erroMessage = 'Start time must be before end time if on the same date.';
          return;
        }
      }

      // If date and time ranges are valid
      this.showError = false;
    }
  }

  getNextDayOccurrence(start: Date, targetDay: number, recurrence: number, end: Date): Date[] {
    const occurrences: Date[] = [];
    const currentDay = start.getDay();

    // Calculate the number of days to the next occurrence of the target day
    const daysUntilNext = (targetDay + 7 - currentDay) % 7;
    let nextDate = new Date(start);
    nextDate.setDate(start.getDate() + daysUntilNext);

    // Add occurrences based on recurrence (e.g., every 1, 2, or 3 weeks), within the start and end date range
    while (nextDate <= end) {
      occurrences.push(new Date(nextDate));

      // Move to the next occurrence based on the recurrence interval
      nextDate.setDate(nextDate.getDate() + (recurrence * 7));
    }

    return occurrences;
  }

  generateAppointmentsForStaff(): void {
    this.appointments = []; // Reset appointments array
    const allStaffMembers = [...this.selectedOptionalUsers, ...this.selectedRequiredUsers];

    this.appointmentDates.forEach((date) => {
      allStaffMembers.forEach((staff) => {
        // Create an appointment object for each staff member and date
        const appointment: MeetingAppointment = {
          StaffMemberID: staff.ID,
          StartDate: date.toISOString().split('T')[0] + ' ' + this.selectedStartRecurringTime, // Format as YYYY-MM-DD
          StartTime: this.selectedStartRecurringTime, 
          EndDate: date.toISOString().split('T')[0] + ' ' + this.selectedEndRecurringTime, // Same day for start and end date
          EndTime: this.selectedEndRecurringTime, 
          LocationID: this.selectedServiceAreaID, 
          ServiceProviderID: this.aapointment.ServiceProviderID,
          BranchID: this.aapointment.BranchID,
          SPType: 'General' // Example type
        };

        // Push appointment into the array
        this.appointments.push(appointment);
      });
    });
    this.ButtonClick()

  }


  generateSingleAppointmentForStaff(): void {
    this.SingleTimeSelectionValidation();
    if (!this.recurrenceStartDate || !this.selectedStartRecurringTime || !this.selectedEndRecurringTime) {
      this.showError = true;
      this.erroMessage = 'Please select a start and end time.';
      return;
    }


    this.appointments = []; // Reset appointments array
    const allStaffMembers = [...this.selectedOptionalUsers, ...this.selectedRequiredUsers];

      allStaffMembers.forEach((staff) => {
        // Create an appointment object for each staff member and date
        const appointment: MeetingAppointment = {
          StaffMemberID: staff.ID,
          StartDate: this.recurrenceStartDate + ' ' + this.selectedStartRecurringTime, 
          StartTime: this.selectedStartRecurringTime,
          EndDate: this.recurrenceStartDate + ' ' + this.selectedEndRecurringTime, 
          EndTime: this.selectedEndRecurringTime,
          LocationID: this.selectedServiceAreaID, 
          ServiceProviderID: this.aapointment.ServiceProviderID,
          BranchID: this.aapointment.BranchID,
          SPType: 'General' // Example type
        };

        // Push appointment into the array
        this.appointments.push(appointment);
      });

    this.ButtonClick()
  }

  public SingleTimeSelectionValidation() {

    if (this.selectedStartRecurringTime && this.selectedEndRecurringTime) {
      let startTime = this.parseTime(this.selectedStartRecurringTime);
      let endTime = this.parseTime(this.selectedEndRecurringTime);

      if (startTime >= endTime) {
        this.showError = true;
        this.erroMessage = 'Start time must be after the end time';
        return;
      }
      else {
        this.showError = false;
      }
    }

  }

  checkAllDays() {
    this.daysOfWeek.forEach(day => {
      this.selectedDays.Week[day] = true;
    });
  }

  onDayChange() {
    const allChecked = this.daysOfWeek.every(day => this.selectedDays.Week[day]);

    if (!allChecked && this.selectedfrequency === 'daily') {
      this.selectedfrequency = 'weekly'; // Switch to weekly if any checkbox is unchecked
    }
  }

  selectYearly() {
    if (this.selectedfrequency = 'yearly') {
      this.recurrence = 52;
    }
  }

  selectDaily() {
    if (this.selectedfrequency === 'daily') {
      this.checkAllDays();
    }
  }

}
